import { render } from "./App.vue?vue&type=template&id=32a2de1e&scoped=true"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=32a2de1e&lang=css"
import "./App.vue?vue&type=style&index=1&id=32a2de1e&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-32a2de1e"]])

export default __exports__